import {AbstractControl, FormGroup, ValidatorFn} from "@angular/forms";

function isValidDateLike(v: any): boolean {
  if (v instanceof Date) return !isNaN(v.getTime());
  if (typeof v === 'string' || typeof v === 'number') {
    const d = new Date(v);
    return !isNaN(d.getTime());
  }
  return false;
}

export const teleRowValidator: ValidatorFn = (control: AbstractControl) => {
  const g = control as FormGroup;
  const tele = g.get('telemonitoring')?.value as boolean | null | undefined;
  const start = g.get('start_date')?.value;
  const end   = g.get('end_date')?.value;
  // const type  = g.get('tmDatesType')?.value as 'end_of_prescription' | 'specific_date' | null;

  if (tele !== true) return null; // se non attivo, la riga è valida

  const errors: any = {};

  if (!isValidDateLike(start)) errors.startRequired = true;

  if (!isValidDateLike(end)) {
    errors.endRequired = true;
  } else if (isValidDateLike(start)) {
    const sd = new Date(start).getTime();
    const ed = new Date(end).getTime();
    if (sd > ed) errors.endBeforeStart = true;
  }

  // se vuoi vincolare qualcosa in più per 'specific_date', aggiungilo qui

  return Object.keys(errors).length ? errors : null;
};
